import React from 'react';
import { Link } from 'react-router-dom';

const udemyAIEngineeringLink = 'https://www.udemy.com/course/machine-learning-deep-learning-model-deployment/?referralCode=E1443BEB8990D90B8A22';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-900">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-900/30 via-cyan-900/30 to-teal-900/30" />
      
      {/* Animated background elements */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-emerald-500/20 rounded-full blur-3xl animate-pulse-slow" />
        <div className="absolute top-3/4 right-1/4 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 right-1/3 w-48 h-48 bg-teal-500/20 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '4s' }} />
      </div>

      <div className="relative z-10 w-full text-center">
        <div className="animate-fade-in px-4 sm:px-6 lg:px-8">
          {/* Main heading */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight mt-16">
            <span className="gradient-text">Be AI Ready</span>
          </h1>
        </div>
        
        {/* Subtitle */}
        <div className="animate-fade-in px-4 sm:px-6 lg:px-8">
          <p className="text-lg md:text-xl lg:text-2xl text-gray-200 mb-8 max-w-4xl mx-auto leading-relaxed">
            <span className="block text-emerald-400 font-semibold">Join 100K+ students already future-ready</span>
          </p>
        </div>
        
        <div className="animate-fade-in px-4 sm:px-6 lg:px-8">
          {/* Featured - Build AI Agents */}
          <div className="mb-8">
            <Link
              to="/build-agents"
              className="inline-flex items-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-400 hover:to-purple-500 text-white font-bold text-lg px-8 py-4 rounded-lg transition-all transform hover:scale-105 shadow-lg"
            >
              🤖 Build AI Agents
            </Link>
          </div>
        </div>
        
        {/* Hero course promo section */}
        <div className="relative animate-slide-up">
          <div className="glass-card p-8 max-w-4xl mx-auto text-center">
            <h3 className="text-gray-900 text-xl font-semibold mb-2">Step Into the World of AI Engineering</h3>
            <p className="text-gray-700 text-sm mb-6">Build, deploy, and serve real AI models and agents with Python, TensorFlow, PyTorch, the OpenAI SDK, and more</p>
            <a
              href={udemyAIEngineeringLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-gradient-to-r from-yellow-500 to-orange-500 text-black font-bold px-8 py-4 rounded-lg hover:from-yellow-400 hover:to-orange-400 transition-all transform hover:scale-105 shadow-lg"
            >
              <span className="mr-2">🎓</span>
              View AI Engineering Course on Udemy
              <span className="ml-2">→</span>
            </a>
          </div>
        </div>

        {/* Stats and CTA Buttons - Moved below promo */}
        <div className="animate-fade-in px-4 sm:px-6 lg:px-8 mt-12">
          {/* Stats */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full animate-pulse" />
              <span className="text-gray-300">80K+ Udemy Students</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16">
            <Link
              to="/courses/vibe-coding"
              className="btn-primary w-full sm:w-auto"
            >
              ✨ Build anything with prompts
            </Link>
            <Link
              to="/courses/ai-engineering"
              className="btn-secondary w-full sm:w-auto"
            >
              🚀 Start AI Journey
            </Link>
            <Link
              to="/courses/data-engineering"
              className="btn-secondary w-full sm:w-auto"
            >
              ⚙️ Master Data Engineering
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;